import { arrowMarkerId } from '../style';

interface ArrowMarkerDefsProps {
  colors: string[];
}

export default function ArrowMarkerDefs({ colors }: ArrowMarkerDefsProps) {
  const unique = [...new Set(colors)];
  return (
    <>
      {unique.map(color => (
        <marker key={color} id={arrowMarkerId(color)} viewBox="0 0 10 10" refX={9.5} refY={5} markerWidth={5.5} markerHeight={5.5} orient="auto-start-reverse">
          <path d="M0,0 L10,5 L0,10 z" fill={color} />
        </marker>
      ))}
    </>
  );
}
